import { render } from "./AssignFormSdvModal.vue?vue&type=template&id=c918ce42&scoped=true"
import script from "./AssignFormSdvModal.js?vue&type=script&lang=js"
export * from "./AssignFormSdvModal.js?vue&type=script&lang=js"

import "./AssignFormSdvModal.vue?vue&type=style&index=0&id=c918ce42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c918ce42"]])

export default __exports__